import {OnDestroy} from '@angular/core';
import {AfterViewInit} from '@angular/core';
import {AgGridAngular} from 'ag-grid-angular';
import {ClientSideRowModelApiModule} from 'ag-grid-community';
import {ClientSideRowModelModule} from 'ag-grid-community';
import {ColDef} from 'ag-grid-community';
import {ColGroupDef} from 'ag-grid-community';
import {RowSelectedEvent} from 'ag-grid-community';
import {GetRowIdFunc} from 'ag-grid-community';
import {GetRowIdParams} from 'ag-grid-community';
import {GridOptions} from 'ag-grid-community';
import {GridReadyEvent} from 'ag-grid-community';
import {GridApi} from 'ag-grid-community';
import {RowSelectionModule} from 'ag-grid-community';
import {RowSelectionOptions} from 'ag-grid-community';
import {ValidationModule} from 'ag-grid-community';
import {ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {v4 as uuidv4} from 'uuid';
import {HostListener} from '@angular/core';
import {Component} from '@angular/core';
import {EventBusService} from '../../../../core/base/angular/client/services/EventBusService/EventBusService';
import {inject} from '@angular/core';
@Component({
	selector:'sample-sales-grid',
	templateUrl:'./SampleSalesGrid.html',
	styles: [],
	styleUrls:['./SampleSalesGrid.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		AgGridAngular,
],
	standalone:true
})
export class SampleSalesGrid implements OnDestroy,AfterViewInit
{
	readonly eventBusService = inject(EventBusService);
	readonly subscription?: Subscription;
	readonly handlerId :string;
	readonly datasetHandlerId :string;
	gridApi?: GridApi;
	columnDefs: (ColDef | ColGroupDef)[] = [{
  "field" : "region",
  "headerName" : "Region",
  "sortable" : true,
  "filter" : true
}, {
  "field" : "product",
  "headerName" : "Product",
  "sortable" : true,
  "filter" : true
}, {
  "field" : "units",
  "headerName" : "Units Sold",
  "sortable" : true
}, {
  "field" : "revenue",
  "headerName" : "Revenue",
  "sortable" : true
}, {
  "field" : "profit",
  "headerName" : "Profit",
  "sortable" : true
}];
	getRowId: GetRowIdFunc = (params: GetRowIdParams) => String(params.data.region);
	defaultColDef: ColDef = { sortable: true, filter: true, resizable: true };
	@ViewChild('salesGrid') salesGrid? : AgGridAngular;
	options: GridOptions = {};
	readonly listenerName = 'salesGrid';
	readonly clazzName = 'com.jwebmp.website.pages.home.SampleSalesGrid';
	constructor( )
	{
		this.datasetHandlerId = this.generateHandlerId();
		this.handlerId = this.generateHandlerId();
		this.subscription = this.eventBusService.listen(this.listenerName, this.handlerId)
		  .subscribe({
		      next: (message: any) => {
		          if (message) {
		              let _rows: any[] = [];
		              if (Array.isArray(message)) {
		                  for (let m of message) {
		                      if (typeof m === 'string') {
		                          try { _rows.push(...(JSON.parse(m) ?? [])); } catch {}
		                      } else {
		                          _rows.push(m);
		                      }
		                  }
		              } else {
		                  if (typeof message === 'string') {
		                      try { _rows = JSON.parse(message); } catch {}
		                  } else {
		                      _rows = Array.isArray(message) ? message : [message];
		                  }
		              }
		              if (_rows) {
		                  let rows = _rows;
		                  if (this.salesGrid?.api) {
		                      this.salesGrid.api.setGridOption('rowData', rows);
		                  } else if (this.salesGrid) {
		                      this.salesGrid.rowData = rows;
		                  }
		              }
		          } else {
		              if (this.salesGrid?.api) {
		                  this.salesGrid.api.setGridOption('rowData', []);
		              } else if (this.salesGrid) {
		                  this.salesGrid.rowData = [];
		              }
		              let rows = [];
		          }
		      },
		      error: (error: any) => {
		          console.log(error);
		      },
		  });
	}
	ngAfterViewInit()
	{
		this.eventBusService.send(this.listenerName, {
            className: this.clazzName,
            listenerName: this.listenerName
        }, this.listenerName);
	}
	private generateHandlerId(): string {
	    return `${this.listenerName}-${uuidv4()}`;
	}
	// Save the grid API when the grid is ready
	  onGridReady(params: any): void {
	    this.gridApi = params.api;
	    
	    this.onSizeColumnsToFit(); // Automatically fit columns on load
	  }
	
	  // Adjust column sizes to fit the grid width
	  onSizeColumnsToFit(): void {
	    if (this.gridApi) {
	      // Defer to avoid AG Grid error #252 (calling API during render cycle)
	      setTimeout(() => this.gridApi?.sizeColumnsToFit(), 0);
	    }
	  }
	
	  // Fit columns when first data is rendered
	  onFirstDataRendered(): void {
	    this.onSizeColumnsToFit();
	  }
	
	  // Fit columns when grid size changes (e.g., window resize, container layout)
	  onGridSizeChanged(): void {
	    this.onSizeColumnsToFit();
	  }
	
	  // Handle browser window resize
	  @HostListener('window:resize', ['$event'])
	  onWindowResize(event: any): void {
	    this.onSizeColumnsToFit();
	  }
	rowSelected($event: RowSelectedEvent<any>) {
	    this.salesGrid?.api.refreshHeader();
	    
	}

	ngOnDestroy()
	{
		this.eventBusService.unregisterListener(this.listenerName, this.handlerId);
	}
}
